// extracted by mini-css-extract-plugin
export default {"container":"cardContainer_container__UHHJc","shadow":"cardContainer_shadow__Sd5eh"};